import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="toc-navigation"
export default class extends Controller {
  static targets = ["content", "link"];
  static classes = ["active"];

  connect() {
    if (!this.hasContentTarget) return;

    const options = {
      root: null,
      rootMargin: "-40% 0px -60% 0px",
      threshold: 0,
    };

    this._observer = new IntersectionObserver(
      this.#handleIntersection,
      options
    );

    const h2Elements = Array.from(this.contentTarget.querySelectorAll("h2")).filter(
      (h2) => !h2.matches("[data-toc-exclude]") && !h2.closest("[data-endnotes]"),
    );

    h2Elements.forEach(h2 => {
      const section = this.#wrapSection(h2);
      this._observer.observe(section);
    });
  }

  disconnect() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  }

  #wrapSection = (h2) => {
    const section = document.createElement("section");
    h2.parentNode.insertBefore(section, h2);
    let nextSibling = h2.nextSibling;
    section.appendChild(h2);

    while (nextSibling && nextSibling.tagName !== "H2") {
      const siblingToMove = nextSibling;
      nextSibling = nextSibling.nextSibling;
      section.appendChild(siblingToMove);
    }

    return section;
  }

  #handleIntersection = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const h2Element = entry.target.querySelector("h2");

        if (!h2Element) {
          return;
        }

        const headingId = h2Element.id;

        const linkTarget = this.linkTargets.find((link) => {
          const anchor = link.querySelector("a");
          return anchor && anchor.getAttribute("href") === `#${headingId}`;
        });

        if (!linkTarget) {
          return;
        }

        this.linkTargets.forEach((link) => {
          link.classList.remove(...this.activeClasses);
        });

        if (linkTarget) {
          linkTarget.classList.add(...this.activeClasses);
        }
      }
    });
  };
}
